import {
  INVITE_STATUS_META,
  INVITE_STATUS_STEPS,
  getStatusStepIndex,
  normalizeInviteStatus,
} from "./inviteMockData";

/**
 * Stacked progress bar (reference style), single green:
 * striped green segments for reached steps, labels inside fill,
 * gray empty segments for upcoming steps.
 */
const InviteStatusTrack = ({ status }) => {
  const normalized = normalizeInviteStatus(status);
  const currentIndex = getStatusStepIndex(normalized);
  const isExpired = normalized === "expired";
  const meta = INVITE_STATUS_META[normalized] || INVITE_STATUS_META.invited;
  const activeIndex = isExpired ? 0 : Math.max(0, currentIndex);

  return (
    <div
      className={`invite-track${isExpired ? " invite-track--expired" : ""}`}
      role="group"
      aria-label={`Status: ${meta.label}`}
    >
      <ol className="invite-track__bar">
        {INVITE_STATUS_STEPS.map((step, index) => {
          const filled =
            !isExpired && index <= activeIndex
              ? true
              : isExpired && index === 0;

          return (
            <li
              key={step.key}
              className={`invite-track__seg${
                filled ? " invite-track__seg--filled" : " invite-track__seg--empty"
              }${index === activeIndex && !isExpired ? " is-current" : ""}`}
            >
              <span className="invite-track__seg-label">{step.label}</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default InviteStatusTrack;
